import React from 'react'

import { object } from 'prop-types'

import BrandContact from '../../Primitive/Brand/component/BrandContact'

const AdvertiseSalesforceForm = ({ pageData, instance }) => {
  const { url } = pageData || {}
  const parsedUrl = new URL(url)
  const retUrl = parsedUrl.origin + '/advertise/thank-you'
  return <BrandContact retUrl={retUrl} brandName={instance.name} />
}

AdvertiseSalesforceForm.propTypes = {
  pageData: object,
  instance: object
}

export default AdvertiseSalesforceForm
